import isEqual from 'lodash.isequal';
import { useEffect } from 'react';
import usePrevious from './usePrevious';

type ResetTableStateArgs<T> = {
	observed: T;
	callbackFn?: () => void;
};

export default function useResetTableStateOnChange<T>({ observed, callbackFn }: ResetTableStateArgs<T>) {
	const prevObserved = usePrevious(observed);
	useEffect(() => {
		if (!isEqual(observed, prevObserved)) {
			callbackFn?.();
			window.scrollTo({
				top: 0,
				behavior: 'smooth'
			});
		}
	}, [observed, prevObserved, callbackFn]);
}
